import React from 'react';
import { Card, CardContent } from "../../tailwind/card";
import { Gauge, ArrowUp } from "lucide-react";
import { Progress } from "../../tailwind/progress";

export const MessagingLimit = ({ current = 850, limit = 1000, tier = "Tier 1" }) => {
  const percentage = (current / limit) * 100;
  
  return (
    <Card className="border-blue-100 dark:border-blue-900 bg-blue-50/50 dark:bg-blue-900/10">
      <CardContent className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-blue-900 dark:text-blue-100">Messaging Limit</h3>
          <Gauge className="h-5 w-5 text-blue-600 dark:text-blue-400" />
        </div>
        
        <div className="mb-4">
          <div className="flex justify-between items-end mb-2">
            <span className="text-2xl font-bold text-gray-900 dark:text-white">{limit / 1000}k</span>
            <span className="text-xs font-medium text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900 px-2 py-0.5 rounded-full">
              {tier}
            </span>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">Customers per 24 hours</p>
        </div>

        <div className="space-y-1.5">
          <div className="flex justify-between text-xs">
            <span className="text-gray-600 dark:text-gray-400">Usage today</span>
            <span className="text-gray-900 dark:text-gray-200 font-medium">{current} / {limit}</span>
          </div>
          <Progress value={percentage} className="h-1.5 bg-blue-200 dark:bg-blue-900" indicatorClassName="bg-blue-600 dark:bg-blue-400" />
        </div>

        <div className="mt-4 flex items-center gap-1.5 text-xs text-blue-700 dark:text-blue-300">
          <ArrowUp className="h-3 w-3" />
          <span>Maintain high quality for 7 days to upgrade</span>
        </div>
      </CardContent>
    </Card>
  );
};